import { animateScroll } from "react-scroll";
import validator from 'validator';

export const scrollToTop = async (elementId) => {
  animateScroll.scrollToTop({ containerId: elementId });
}

export const validMail = async (email) => {
  return validator.isEmail(email);
}